import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { pill, scrollBody, actionBtn, ProgressHeader, WebEntryLayout } from './entryHelpers';
import { patientAuthFlow } from '../../auth/patientAuthFlow';

const relationships = ['Spouse', 'Parent', 'Sibling', 'Child', 'Other'];

const labelStyle: React.CSSProperties = {
  fontSize: 9,
  fontWeight: 600,
  color: T.textTer,
  fontFamily: T.font,
  marginBottom: 4,
};

const fieldStyle: React.CSSProperties = {
  width: '100%',
  padding: '10px 14px',
  borderRadius: 10,
  border: `1px solid ${T.border}`,
  background: T.ice,
  fontSize: 12,
  fontFamily: T.font,
  color: T.text,
  outline: 'none',
  boxSizing: 'border-box',
};

export default function PatRegEmergencyScreen() {
  const navigate = useNavigate();
  const [contactName, setContactName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [relationship, setRelationship] = useState('Spouse');

  return (
    <WebEntryLayout>
    <div style={{ flex: 1, background: T.white, display: 'flex', flexDirection: 'column', fontFamily: T.font }}>
      <ProgressHeader title="Emergency Contact" step={5} total={8} onBack={() => navigate(-1)} />

      <div style={scrollBody}>
        {/* Contact Name */}
        <div>
          <div style={labelStyle}>Contact Name</div>
          <input
            type="text"
            placeholder="Emergency contact name"
            value={contactName}
            onChange={(e) => setContactName(e.target.value)}
            style={fieldStyle}
          />
        </div>

        {/* Phone Number */}
        <div>
          <div style={labelStyle}>Phone Number</div>
          <input
            type="tel"
            inputMode="numeric"
            maxLength={10}
            placeholder="98765 43211"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, '').slice(0, 10))}
            style={fieldStyle}
          />
        </div>

        {/* Relationship */}
        <div>
          <div style={labelStyle}>Relationship</div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {relationships.map((r) => (
              <div
                key={r}
                onClick={() => setRelationship(r)}
                style={{ ...pill(r, T.navy, relationship === r), cursor: 'pointer' }}
              >
                {r}
              </div>
            ))}
          </div>
        </div>

        {/* Next Button */}
        <button
          onClick={() => {
            patientAuthFlow.completeEmergency({
              emergencyName: contactName,
              emergencyPhone: phoneNumber,
              emergencyRelation: relationship,
            });
            navigate('/patient/register/abha');
          }}
          style={{
            ...actionBtn('Next', T.teal, T.white),
            width: '100%',
            padding: 13,
            borderRadius: 12,
            fontSize: 13,
          }}
        >
          Next
        </button>
      </div>
    </div>
    </WebEntryLayout>
  );
}
